<ig-card class="event-card" tabindex="0" (keypress)="enterItemByKeyboard($event)"
         [isPromotionImage]="event.isPromotionImage"
         [picture]="event.cover?.source"
         [containTitle]="true"
         [ngClass]="{'pinned':event.pinnedTime}"
         [alt]="event.title||event.name"
         (click)="showDetails()">
    <div title>
        <div *ngIf="isMobile" class="mobile-title">
            <p>{{ event.title || event.name }}</p>
        </div>

        <span class="align-center" *ngIf="event.eventTimes&&event.eventTimes.length<=1">
            <mat-icon>date_range</mat-icon>
            <span
                *ngIf="event.startTimeFormatted">{{ event.startTimeFormatted }}{{ event.endTimeFormatted ? ' - ' + event.endTimeFormatted : '' }}</span>
        </span>

        <span class="align-center" *ngIf="event.eventTimes&&event.eventTimes.length>1">
            <mat-icon>date_range</mat-icon>
            Multiple Dates Event - See Details
        </span>
    </div>

    <div detail>
        <div class="ig-title">{{ event.title || event.name }}</div>
        <div>
            <mat-icon>account_balance</mat-icon>
            Hosted by: {{ event.owner?.name || event.name }}
        </div>
        <div>
            <mat-icon>pin_drop</mat-icon>
            <span *ngIf="event.venue">{{ event.venue }}, </span>
            <span>{{ event.isOnlineEvent ? 'Online Event' : (event.address?.address || '(no location)') }}</span>
        </div>

        <div class="details">
            <span class="editor-choice" *ngIf="event.isChoice">
                <mat-icon>favorite_border</mat-icon>
                {{ editorChoiceText }}
            </span>
            <ig-button (trigger)="showDetails()">DETAILS</ig-button>
        </div>
    </div>
</ig-card>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/event.card/visitor.event.card.component.html